import React, { createContext, useContext, useState, useEffect } from "react";
import { GetOwnerDetailsFromToken, fetchUserDetailsByUserId, fetchLinkedAccounts } from '../../Services/userService.js';
import { setMaxLinkedOrganizations } from '../../config/appSettings.js';
import { GetUserDetailsFromToken } from '../../Services/employeeService.jsx';
import {fetchEmpDetailsByUserId} from '../../Services/ManagerService.jsx'

const UserContext = createContext();

export const UserProvider = ({ children }) => {
    const [userDetails, setUserDetails] = useState(null);
    const [empDetails, setEmpDetails] = useState(null);
    const [userId, setuserId]  = useState();
    const [employeeData, setEmpData]  = useState();
    const [userRole, setUserRole]  = useState();
    const [initial, setInitials] = useState();
    const [loader, setLoader] = useState(true);
    const [companyName, setCompanyName] = useState('');
    const [linkedAccounts, setAccounts] = useState([]);

    useEffect(() => {
        const fetchEmployeeData = async () => {
            const isAuth = localStorage.getItem("isauth") === "true";
            if (!isAuth) return;

            try {
                const userData = await GetUserDetailsFromToken();
                if(userData?.companyEmail){
                    setEmpDetails(userData);                    
                    //setInternalEmployeeEmail(userData.companyEmail );  // Set fetched data
                    const initials = getInitials(userData.name);
                    setInitials(initials);
                    setLoader(false);
                }
            } catch (error) {
                console.error("Error fetching user data:", error);
            }
        };

        fetchEmployeeData(); 
    }, []); 

    useEffect(() => {
        const fetchUserData = async () => {
            const isAuth = localStorage.getItem("isauth") === "true";
            if (!isAuth) return;

            try {
                // conditionally call getownerdetails from token based on loggedin person 
                const userData = await GetOwnerDetailsFromToken();
                console.log("userData",userData);                
                setuserId(userData?.userId)
                setUserRole(userData?.jobTitle)
            } catch (error) {
                console.error("Error fetching user data:", error);
            }
        };

        fetchUserData(); 
    }, []); 
    function getInitials(fullName) {
        if (!fullName) return '';
      
        const nameParts = fullName.trim().split(' ');
        return nameParts
          .map(part => part[0].toUpperCase())
          .join('');
      }
    useEffect(() => {
        const fetchOwnerData = async () => {
            if (!userId) return;  // Ensure userId is available before making API call  
            try {
                if(userRole === 'Employee' ) {                    
                    const empData = await fetchEmpDetailsByUserId(userId);                    
                    setEmpData(empData);
                    const fullName =`${empData?.firstName} ${empData?.lastName}`;
                    const initials = getInitials(fullName);
                    const companyName = empData?.companyName
                    setCompanyName(companyName);
                    setInitials(initials)
                }
                else {
                    const [userData, linkedRes] = await Promise.all([
                        fetchUserDetailsByUserId(userId),
                        fetchLinkedAccounts()
                    ]);
                    setUserDetails(userData);
                    const fullName = `${userData?.firstName} ${userData?.lastName}`;
                    const initials = getInitials(fullName);
                    setCompanyName(userData?.entityName ?? "");
                    setInitials(initials);

                    const payload = linkedRes?.success ? linkedRes.data : linkedRes || {};
                    const apiLimit =
                        payload.maxLinkedOrganizations ??
                        payload.MaxLinkedOrganizations ??
                        payload.applicationSettings?.maxLinkedOrganizations ??
                        payload.ApplicationSettings?.MaxLinkedOrganizations;
                    if (apiLimit != null) {
                        setMaxLinkedOrganizations(apiLimit);
                    }
                    let linked = payload.linkedAccounts || payload.LinkedLLCs || payload.linkedLLCs || [];
                    if (!Array.isArray(linked) || linked.length === 0) {
                        const groups = payload.groups || payload.Groups || [];
                        linked = (groups || []).flatMap(g => g.linkedLLCs || g.LinkedLLCs || g.linkedLLCs || []);
                    }
                    if (!Array.isArray(linked) || linked.length === 0) {
                        linked = payload.accounts || payload.Accounts || [];
                    }
                    let normalizedLinked = (linked || []).map(normalizeAccount);
                    const map = new Map();
                    normalizedLinked.forEach(a => {
                        const key = a.oid || a.emailId;
                        if (key && !map.has(key)) map.set(key, a);
                    });
                    normalizedLinked = Array.from(map.values());
                    if (normalizedLinked.length === 0) {
                        const fallback = normalizeAccount({
                            oid: userData?.oid || userData?.id,
                            emailId: userData?.email || userData?.emailId,
                            firstName: userData?.firstName,
                            lastName: userData?.lastName,
                            companyName: userData?.companyName
                        });
                        normalizedLinked = (fallback.oid || fallback.emailId) ? [fallback] : [];
                    }
                    setAccounts(normalizedLinked);
                }
                setLoader(false);
            } catch (error) {
                console.error("Error fetching user data:", error);
            }
        };
    
        fetchOwnerData();
    }, [userId,userRole]);  // Runs only when userId changes and is not null

    const normalizeAccount = (a = {}) => ({
        oid: a.oid || a.Oid || a.oidValue || a.id || null,
        emailId: a.emailId || a.EmailId || a.email || null,
        role: a.role || a.Role || null,
        companyName: a.companyName || a.CompanyName || a.company || null,
        firstName: a.firstName || a.FirstName || a.first || null,
        lastName: a.lastName || a.LastName || a.last || null,
    });

    return (
        <UserContext.Provider value={{ userDetails, empDetails, employeeData, initial, companyName, loader, linkedAccounts }}>
            {children}
        </UserContext.Provider>
    );
};

// Custom Hook to Use UserContext
export const useUser = () => useContext(UserContext);
